<template lang="pug">
  page
    section.page-header(:style="`background-image: url('${bg}')`" )
      .info-container
        h1.text-center {{product.name}}
        p.text-center(v-if="product.startup") {{product.startup.name}}

    section.product-content
      .container(v-if="sending")
        content-placeholders(:animated="true")
          .row
            .col-sm-6
              content-placeholders-img
            .col-sm-6
              content-placeholders-heading
              content-placeholders-text
          .row.pt-5
            .col-sm-6
              content-placeholders-heading
              content-placeholders-text
            .col-sm-6
              content-placeholders-img
      .container(v-else)
        .row
          .col-sm-6.pr-3(v-if="product.image")
            img.img-fluid(:src='$backend+"/storage/images/"+product.image')
          .col-sm-6.pl-3
            h1 {{product.name}}
            div
              span.badge.bg-azure {{product.sector}}
              span.badge.bg-teal.ml-1 {{product.subsector}}
            p.mt-3.text-justify {{product.usecase}}
            p 
              b Website : 
              a(:href="product.website") {{product.website}}
            .row
              .col-6
                p 
                  b Current Status: 
                  span.badge.bg-cyan {{product.stage}}
              .col-6
                p 
                  b Business Model: 
                  span.badge.bg-green {{product.model}}

        .row.mt-4
          .col-sm-6
            h2 Product Description
            .text-justify(v-html="product.brief")
          .col-sm-6(v-if="product.video")
            .video-block
              a.video-pop-up(@click="open_video()")
                img(:src="`https://img.youtube.com/vi/${youtube_id}/hqdefault.jpg`")
            #youtube.modal.modal-blur.fade.show(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true' )
              .modal-dialog.modal-dialog-centered.modal-lg(role='document')
                .modal-content
                  .modal-body
                    iframe(type='text/html' width='670' height='400' :src="`//www.youtube.com/embed/${youtube_id}`" frameborder='0')

</template>

<script>
// @ is an alias to /src
import page from '@/components/frontend/page'
import magnificPopup from 'magnific-popup';
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ProductDetails',
  components: {
    page
  },
  props: ['id'],
  data(){
    return {
      product : {}
    }
  },
  computed:{
    bg(){
      if(this.product.image){
        return `${this.$backend}/storage/images/${this.product.cover}`;
      }
      else{
        return '';
      }
    },
    youtube_id(){
      var url = this.product.video??'';
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
      // return video_id;
    },
    ...mapState('api', ['sending']),
  },
  methods: {
    open_video(){
      $('#youtube').modal('show');
    },
    load_data(){
      var vm = this;
      this.call({ _vm: this, endpoint:'products/'+this.id, method: 'GET'})
        .then((response)=>{
          vm.product = response;
        });
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    this.load_data();
    $('.video-pop-up').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/_mixins';

.text-justify{
  text-align: justify;
}

.video-block{
  display: inline-block;
  background: white;
  padding: 10px 10px 10px 10px;
  box-shadow: 1px 1px 3px #666;

  iframe{
    max-width: 100%;
  }

  img{
    max-width:100%;
  }

  .video-pop-up{
    position: relative;
    height: 100%;
    display: block;
    &:before{
      content: '';
      position: absolute;
      display: flex;
      justify-content:center;
      align-items: center;
      width: 100%;
      height: 100%;
      background-image: url('../../assets/img/play-button.png');
      background-size: 100px;
      background-position: center;
      background-repeat: no-repeat;
      background-color: rgba(200,200,200,.4);
      backdrop-filter: blur(2px);
      cursor: pointer;
    }
  }
}

.page-header{
  min-height: 50vh;
  background: #ccc;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  position: relative;
  padding-top: 80px;
  display: flex;

  &::before{
    background-color: #252C30;
    zoom: 1;
    opacity: 0.7;
    content: "";
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    height: 100%;

  }

  

  .info-container{
    z-index: 99;
    h1{
      color: white;
      z-index: 100;
      font-size: 3rem;
    }
    p{
      color: white;
      z-index: 100;
    }
  }
}

.product-content{
  padding-top: 60px;
  padding-bottom: 60px;

  h1{
    font-size: 2rem;
  }
}

</style>
